import React from "react";

const quote = () => {
  return <div>quote</div>;
};

export default quote;
